import { type DocumentTypeEnum_value } from 'components/framework/models/generated/types';
import RecordAction from './RecordAction';
import { Page } from 'components/framework/models';
import type ApplicationModel from 'components/framework/ApplicationModel';

export class PageAction extends RecordAction<Page> {
  recordTypes = ['Page'];
  documentTypes: readonly DocumentTypeEnum_value[] = Page.DOCUMENT_TYPES;

  showForRecord(record: ApplicationModel): record is Page {
    return (
      super.showForRecord(record) &&
      this.documentTypes.includes(record.documentType)
    );
  }
}
